import { Seat } from "@ravalmatic/bridge-engine/core";
import { Avatar } from "../players/Avatar";
import { getPlayerIdentity, isLocalPlayerSeat } from "../PlayerSeats";
import { GameVars } from "../../../GameVars";

export class Declarer extends Phaser.GameObjects.Container {

    private readonly avatar: Avatar;

    constructor(scene: Phaser.Scene, private readonly seat: Seat) {

        super(scene);

        const identity = getPlayerIdentity(seat, GameVars.gameData?.playerAvatarId);
        const avatar = new Avatar(scene, identity.avatarId, false, 0, identity.profileId);
        this.avatar = avatar;

        const avatarFrame = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "avatar_frame_3");
        avatarFrame.scale = .89;
        avatar.add(avatarFrame);

        const label = new Phaser.GameObjects.Text(scene, 0, 78, "DECLARER", {
            fontFamily: "Baloo2-Bold",
            fontSize: "26px",
            color: "#00ffff"
        }).setOrigin(.5, 0);
        const orientations = ["NORTH", "EAST", "SOUTH", "WEST"];
        const orientation = new Phaser.GameObjects.Text(scene, 0, 112, orientations[seat], {
            fontFamily: "Baloo2-SemiBold",
            fontSize: "24px",
            color: "#ffffff"
        }).setOrigin(.5, 0);

        this.add([avatar, label, orientation]);
    }

    public setPlayerAvatarId(avatarId: number): void {

        if (isLocalPlayerSeat(this.seat)) this.avatar.setAvatarId(avatarId);
    }
}
